import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLimitReached(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.283,
    height: 70,
    viewBox: "0 0 74.283 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.739 53.563L46.5 5.327a10.882 10.882 0 00-18.715 0L1.545 53.563A10.876 10.876 0 0010.9 70h52.482a10.878 10.878 0 009.357-16.437zm-35.6 7.732a4.352 4.352 0 114.355-4.354 4.358 4.358 0 01-4.353 4.354zm4.352-17.41a4.352 4.352 0 11-8.7 0V22.122a4.352 4.352 0 018.7 0z",
    fill: "#fa6450"
  })));
}

export { SvgLimitReached as ReactComponent };
//# sourceMappingURL=LimitReached.svg.js.map
